import {
  Status as StatusFavoris,
  loadingDeleteFavoris,
  succeededDeleteFavoris,
  failedDeleteFavoris,
  idleDeleteFavoris,
  showModalDeleteFavoris,
} from 'redux/features/favoris/slice'
import {
  makeSelectFavoris,
  makeSelectStatusDeleteFavoris,
  makeSelectErrorDeleteFavoris,
} from 'redux/features/favoris/selectors'
import { useAppDispatch, useAppSelector } from 'redux/hooks'
import { fetchWithCheckAuthorization } from 'utils/fetchWithAuthorization'

interface ReturnProps {
  show: boolean
  loading: boolean
  error: string | null
  showModal: () => void
  confirmDeleteSelectedFavoris: () => void
  cancelDeleteFavoris: () => void
  countFavorisChecked: number
}

const useDeleteFavoris = (): ReturnProps => {
  const favoris = useAppSelector(makeSelectFavoris)
  const statusSupprimerTous = useAppSelector(makeSelectStatusDeleteFavoris)
  const errorSupprimerTous = useAppSelector(makeSelectErrorDeleteFavoris)
  const dispatch = useAppDispatch()

  const deleteSelectedFavoris = async () => {
    try {
      dispatch(loadingDeleteFavoris())
      const selection = Object.values(favoris).filter(
        ({ isChecked }) => isChecked
      )
      const promises = selection.map(({ uidParcelle }) =>
        fetchWithCheckAuthorization(`/api/favori/${uidParcelle}`, {
          method: 'DELETE',
        })
      )
      const responses = await Promise.all(promises)
      responses.forEach((response) => {
        if (response.ok && response.status === 204) return
        switch (response.status) {
          case 401:
            throw Error(response.statusText)
          case 500:
            throw Error('Erreur interne')
          default:
            throw Error('Une erreur est survenue')
        }
      })
      dispatch(succeededDeleteFavoris())
    } catch (err: unknown) {
      console.error(err)
      dispatch(failedDeleteFavoris((err as Error).toString()))
    }
  }

  const showModal = () => dispatch(showModalDeleteFavoris())

  const confirmDeleteSelectedFavoris = () => deleteSelectedFavoris()

  const cancelDeleteFavoris = () => dispatch(idleDeleteFavoris())

  return {
    show:
      statusSupprimerTous === StatusFavoris.ShowModalDeleteFavoris ||
      statusSupprimerTous === StatusFavoris.Pending ||
      statusSupprimerTous === StatusFavoris.Failed,
    error:
      (statusSupprimerTous === StatusFavoris.Failed && errorSupprimerTous) ||
      null,
    loading: statusSupprimerTous === StatusFavoris.Pending,
    showModal,
    confirmDeleteSelectedFavoris,
    cancelDeleteFavoris,
    countFavorisChecked: Object.values(favoris).filter(
      ({ isChecked }) => isChecked
    ).length,
  }
}

export default useDeleteFavoris
